import { render, staticRenderFns } from "./NoticeTemplateListing.vue?vue&type=template&id=73a47494&"
import script from "./NoticeTemplateListing.vue?vue&type=script&lang=js&"
export * from "./NoticeTemplateListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports